<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUser">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUser.firstname }} {{ activeUser.lastname }}</p>
      <small>{{ role }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          key="onlineImg"
          :src="userImage"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
        <!-- <img
          v-else
          key="onlineImg"
          src="logo.png"
          alt="default-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        /> -->
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="$router.push('/profile')">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profil</span>
          </li>

          <!-- <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span> -->
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import VueCookies from "vue-cookies";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin";
import store from "@/store/store";

export default {
	mixins: [dbFieldConvertorMixin],
	data() {
		return {
			image_url:
        "data:image/png;base64,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",
			role: "",
			userImage: "avatar_default.png"
		};
	},
	computed: {
		activeUser: () => {
			/*
			 * if (Object.keys(store.state.activeUser).length < 1) {
			 *   //console.log("getting sessionStorage userInfo")
			 */
			return VueCookies.get("userInfo");
			/*
			 * }
			 * return store.state.activeUser;
			 */
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	watch: {
		allCollaboratorsAvatar: function() {
			this.userImage = this.getCollaboratorAvatar(this.activeUser.id);
		},
	},
	created() {
		this.getAllCollaboratorsAvatar();
		this.getRole();
		this.userImage = this.getCollaboratorAvatar(this.activeUser.id);
	},
	methods: {
		getUserImage(user) {
			if(user.image_url){
				this.$http
					.get(this.$store.state.backendApiUrl + "users/getImg/" + user.id)
					.then(image => {
						this.userImage = image.data;
					})
					.catch(err => {
						//console.log(err);
					});
			}
			else{
				this.userImage = null;
			}
		},

		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return "avatar_default.png";
		},

		logout() {
			// Removing the jwt does disconnect the user and user's data
			VueCookies.remove("nid");
			VueCookies.remove("kb");
			VueCookies.remove("aspi");
			VueCookies.remove("userInfo");
			this.$router.push("/login");
		},
		// SET ROLE NAME DEPENDING ON ROLE
		getRole() {
			this.role = this.getUserTitle(VueCookies.get("userInfo").type);
		},

		/**
		 * Query our API to fetch all the rankwell collaborators avatar
		 */
		getAllCollaboratorsAvatar() {
			this.$store.dispatch("getAllCollaboratorsAvatar");
		},
	}
};
</script>
